import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { operatorHitListOrder, payOutList, payOutOutExcel, payOutPush, queryPayOutOrder, returnOrderStatus } from '@/api/payment';
import infoList from '@/mixins/infoList';
import { formatTimeToStr } from '@/utils/date';
import { getDict } from '@/utils/dictionary';
export default {
  name: 'Order',
  mixins: [infoList],
  data: function data() {
    return {
      zeroTime: null,
      currentTime: null,
      orderStatus: 'all',
      orderStatusObj: {},
      listApi: payOutList,
      payOutime: null,
      payGateWay: null,
      countryList: []
    };
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.initPage();
            _context.next = 1;
            return _this.getOrderStatus();
          case 1:
            _context.next = 2;
            return _this.getTableData();
          case 2:
            _context.next = 3;
            return _this.getDictData();
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    initPage: function initPage() {
      this.currentTime = formatTimeToStr(new Date());
      this.zeroTime = formatTimeToStr(new Date() - 604800000);
      this.formatTimeOne(this.zeroTime, 'start');
      this.formatTimeOne(this.currentTime, 'end');
    },
    getDictData: function getDictData() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 1;
              return getDict('country');
            case 1:
              _this2.countryList = _context2.sent;
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getOrderStatus: function getOrderStatus() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 1;
              return returnOrderStatus();
            case 1:
              res = _context3.sent;
              if (res.code === 0) {
                _this3.orderStatusObj = res.data;
                _this3.searchInfo.OrderStatus = _this3.searchOption(_this3.orderStatusObj, _this3.orderStatus);
              }
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    pushMessage: function pushMessage(id) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 1;
              return payOutPush({
                OrderId: id
              });
            case 1:
              res = _context4.sent;
              if (!(res.code === 0)) {
                _context4.next = 2;
                break;
              }
              _this4.$message.success(res.msg);
              _context4.next = 2;
              return _this4.getTableData();
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    backHoldin: function backHoldin(id) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 1;
              return operatorHitListOrder({
                OrderId: id
              });
            case 1:
              res = _context5.sent;
              if (!(res.code === 0)) {
                _context5.next = 2;
                break;
              }
              _this5.$message.success(res.msg);
              _context5.next = 2;
              return _this5.getTableData();
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    onSumitPayOutime: function onSumitPayOutime() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var res;
        return regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!(!_this6.payOutime && _this6.payOutime.length < 2)) {
                _context6.next = 1;
                break;
              }
              _this6.$message.warning('请输入批量查询代付订单时间');
              return _context6.abrupt("return");
            case 1:
              if (_this6.payGateWay) {
                _context6.next = 2;
                break;
              }
              _this6.$message.warning('请输入批量查询代付的网关');
              return _context6.abrupt("return");
            case 2:
              _context6.next = 3;
              return queryPayOutOrder({
                gateId: _this6.payGateWay,
                startTime: _this6.payOutime[0] / 1000,
                endTime: _this6.payOutime[1] / 1000
              });
            case 3:
              res = _context6.sent;
              if (res.code === 0) {
                _this6.$message.success('查询成功');
              }
              _this6.payGateWay = null;
              _this6.payOutime = null;
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    payOutExcel: function payOutExcel() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var res;
        return regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 1;
              return payOutOutExcel(_this7.searchInfo);
            case 1:
              res = _context7.sent;
              if (res.code === 0) _this7.$message.success(res.data);
            case 2:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    }
  }
};